














































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IEmail } from "@/models/emails";
import { IState } from "@/store";
import { IClient } from "@/models/clients";
import i18n from "@/i18n";

@Component({
  computed: {
    ...mapState({
      clientEmails(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: this.dataModule,
          scope: this.selectorDataScope
        });
      },
      selectorDataScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/selectorScope`](this.clientId);
      }
    })
  }
})
export default class ClientEmailSelect extends Mixins(
  RequestPromises,
  Context
) {
  // Getters
  public clientEmails!: IEmail[];
  public selectorDataScope!: string;

  @Prop({ required: true })
  public value;

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: true })
  public isRequired!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: "email_id" })
  public selectType!: string;

  @Prop({ default: false })
  public preselectFirst!: boolean;

  @Prop({ default: () => i18n.t("_.email") })
  public label!: string;

  public dataModule: string = DataModules.CLIENTS_EMAILS;

  public isLoading = true;

  public async created() {
    try {
      await this.getClientEmails();
      const defaultEmail = this.$_.find(this.clientEmails, ["default", true]);

      if (!this.value && this.preselectFirst) {
        this.selectFirstEmail();
      }

      if (!this.value && defaultEmail && this.isRequired) {
        this.selected = this.getEmailValue(defaultEmail);
      }
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }

    this.isLoading = false;
  }

  public selectFirstEmail() {
    if (!this.clientEmails.length) return;
    this.selected = this.getEmailValue(
      this.$_.head(this.clientEmails) as IEmail
    );
  }

  public getClientEmails() {
    return this.$store.dispatch(`data/${this.dataModule}/list`, {
      id: this.clientId,
      params: {
        limit: 0,
        offset: 0,
        order: "-default,-id"
      },
      scope: this.selectorDataScope,
      vm: this
    });
  }

  public getEmailValue(email: IEmail) {
    return this.selectType === "email_id" ? email.id : email.email;
  }

  public get selected() {
    return this.value;
  }

  public set selected(value) {
    if (value === "new") {
      return;
    }
    this.$emit("input", value);
  }

  public async onEmailsChange(value: string | number) {
    if (value !== "new") {
      this.selected = value;
      return;
    }
    this.isLoading = true;
    const preSelected = this.selected;
    this.selected = "";
    this.$nextTick(() => {
      this.selected = preSelected;
    });
    const modal = await this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import("@/components/app/global/client/addEditClientEmailsModal.vue"),
        props: {
          clientId: this.clientId
        },
        width: 540,
        onCancel: () => {
          this.isLoading = false;
        },
        events: {
          success: async (email: IEmail) => {
            this.selected =
              this.selectType === "email_id" ? email.id : email.email;
            this.isLoading = false;
            modal.close();
          }
        }
      }
    });
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: this.dataModule,
      scope: this.selectorDataScope,
      vm: this
    });
  }
}
